
import React from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../../product-page/data-services/store";
import SearchIcon from "../../../../ui/svg/common/search";



/**
 * the entry point
 */
const SearchFilter = () => {

    const dispatch = useAppDispatch();
    const techSpecsSearchPlugins = useAppSelector((store) => store.techSpecsSearchPlugins);
    return (
        <div className="py-4 relative float-right dv-search-plugins">
            <input id="txtSearchPlugins" value={techSpecsSearchPlugins} className="search-plugins placeholder:text-slate-400 block bg-white border-b " placeholder="   Search plugins" type="text"
                   onChange={ evt => {
                       document.getElementById('tech-spacs-tab-content')?.scrollIntoView();
                       dispatch(
                           rootActions.main({
                               techSpecsSearchPlugins: evt.target.value,
                           })
                       );
                   }}/>
            <span className="absolute right-0" style={{top:"20px"}}><SearchIcon width="13px" color="#252525" title="Search plugins"  /></span>
        </div>
    )
};

export default SearchFilter;